/** S3 folder for all accreditation form images (uploads + crops). Keep in sync with dashboard/server.js */
export const ACCREDITATION_S3_PREFIX = 'Accreditation/2028';

export const ACCREDITATION_FORM_ID = '68e6505866f25479291b933f';

export function getAccreditationUploadEndpoint(apiUrl) {
  const base = String(apiUrl || '').trim().replace(/\/$/, '');
  return base ? `${base}/ems/uploads` : '/api/ems/uploads';
}

function walkFormComponents(components, handler) {
  if (!Array.isArray(components)) return;
  components.forEach((comp) => {
    if (!comp) return;
    handler(comp);
    if (Array.isArray(comp.components)) walkFormComponents(comp.components, handler);
    if (Array.isArray(comp.columns)) {
      comp.columns.forEach((col) => walkFormComponents(col?.components, handler));
    }
    if (Array.isArray(comp.rows)) {
      comp.rows.forEach((row) => {
        if (Array.isArray(row)) {
          row.forEach((cell) => walkFormComponents(cell?.components, handler));
        }
      });
    }
  });
}

/**
 * Route Form.io file fields on the accreditation form through /api/ems/uploads
 * so the server stores objects under Accreditation/2028 in S3 only.
 * Fetch streams the object same-origin via /api/ems/uploads/Accreditation/2028/...
 * (optional AWS_S3_SIGNED_REDIRECT=true uses a 302 to a signed S3 URL).
 * /api/ems/uploads requires JWT auth on POST; Bearer is attached via options.headers.
 */
export function configureAccreditationFormFileUploads(components, apiUrl) {
  const uploadUrl = getAccreditationUploadEndpoint(apiUrl);
  const token = localStorage.getItem('token');
  walkFormComponents(components, (comp) => {
    if (comp.type !== 'file') return;
    // Force server-controlled upload → S3 Accreditation/2028 (ignore Form Builder local/url mix).
    comp.storage = 'url';
    comp.url = uploadUrl;
    comp.dir = ACCREDITATION_S3_PREFIX;
    // Avoid Form.io "upload only" hiding the stored file after save.
    if (comp.uploadOnly) comp.uploadOnly = false;
    if (token) {
      comp.options = {
        ...(comp.options || {}),
        headers: { Authorization: `Bearer ${token}` },
      };
    }
  });
}
